<template>
    <div class="pagePart pagePart-thankyou">
        <div class="pagePart-in">
            <div class="textcontent">
                <div class="thankyouPage-calculator">
                    <h1 class="pageTitle">Děkujeme</h1>
                    <p>Vaši poptávku jsme odeslali prodejci<strong v-if="contact"> {{contact.name}}</strong>, v
                        nejbližších dnech od něj obdržíte nabídku.
                        <span v-if="demandInformation.withWork">Současně vás bude v nejbližších dnech kontaktovat kolega z portálu NejŘemeslníci.cz.</span>
                        Kopii vaší poptávky se soupisem materiálu a kontakty
                        na prodejce najdete i ve svém e-mailu.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name:     'CalculationDemandThank',
        computed: {
            ...mapGetters('calculation', ['contactId', 'demandInformation']),
            ...mapGetters('locator', ['contactById']),
            contact() {
                return this.contactById(this.contactId);
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            const thankYouElement = document.getElementById('calculator-thank-you');
            if (thankYouElement) {
                thankYouElement.style.display = 'block';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/demand/DemandThank.vue